import { useIntl } from 'react-intl'

function useCruiseCabinTypeLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    Inside: intl.formatMessage({
      id: '83bgeFoEde',
      defaultMessage: 'Inside',
      description: 'Cruise cabin type label for inside cabins',
    }),
    Oceanview: intl.formatMessage({
      id: 'tEI/vXMo8v',
      defaultMessage: 'Oceanview',
      description: 'Cruise cabin type label for oceanview cabins',
    }),
    Window: intl.formatMessage({
      id: 'Yth08Uo7Z5',
      defaultMessage: 'Window',
      description: 'Cruise cabin type label for window cabins',
    }),
    'Oceanview / Window': intl.formatMessage({
      id: 'MEVgbDckrM',
      defaultMessage: 'Oceanview / Window',
      description: 'Cruise cabin type label for combined oceanview and window cabins',
    }),
    Balcony: intl.formatMessage({
      id: 'ExjpAlt86t',
      defaultMessage: 'Balcony',
      description: 'Cruise cabin type label for balcony cabins',
    }),
    Suite: intl.formatMessage({
      id: 'qlMlqOlZmv',
      defaultMessage: 'Suite',
      description: 'Cruise cabin type label for suite cabins',
    }),
  }
}

export default useCruiseCabinTypeLabels
